/* eslint-disable react/require-default-props */
import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

const CardMedia = ({
  children,
  component: Component = 'img',
  src,
  aspect,
  ...other
}) => {

  const classes = classNames('sui-object-cover sui-w-full', {
    'sui-aspect-square': aspect === 'square',
    'sui-aspect-video': aspect === 'wide'
  });

  return (
    <Component
      className={classes}
      src={src}
      {...other}
    >
      {children}
    </Component>
  );
};

CardMedia.displayName = 'CardMedia';

CardMedia.propTypes = {
  /**
   * The content of the component.
   */
  children: PropTypes.node,
  /**
   * The component used for the root node.
   * Either a string to use a HTML element like 'img' or 'picture', or an external custom component.
   * @default 'img'
   */
  component: PropTypes.elementType,
  /**
   * The source path for the image if your are using an `img` component
   */
  src: PropTypes.string,
  /**
   * The aspect ratio to use.
   */
  aspect: PropTypes.oneOf(['square', 'wide']),
};

CardMedia.defaultProps = {
};

export { CardMedia };